"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _validateFursanIdentifier = require("@tajawal/web-payment-sdk-v2/lib/stores/validate-fursan-identifier.store");
var _user = _interopRequireDefault(require("./user.store"));
var _travellerList = _interopRequireDefault(require("./traveller-list.store"));
var _traveller = _interopRequireDefault(require("./traveller.store"));
var _subscribe = _interopRequireDefault(require("./subscribe.store"));
var _verifyUserByPhone = _interopRequireDefault(require("./verify-user-by-phone.store"));
var _resendVerifyEmail = _interopRequireDefault(require("./resend-verify-email.store"));
var _resendVerifyPhone = _interopRequireDefault(require("./resend-verify-phone.store"));
var _updateRegistration = _interopRequireDefault(require("./update-registration.store"));
var _refreshToken = _interopRequireDefault(require("./refresh-token.store"));
var _genericLookup = _interopRequireDefault(require("./generic-lookup.store"));
/**
 * profile page store
 */
let ProfilePageStore = /*#__PURE__*/(0, _createClass2.default)(
/**
 * constructor
 * @param {Object} initialState
 * @param {Object} $env
 */
function ProfilePageStore(initialState = {}, $env) {
  (0, _classCallCheck2.default)(this, ProfilePageStore);
  this.$env = $env;
  this.userStore = new _user.default(initialState.userStore);
  this.updateRegistration = new _updateRegistration.default(initialState.updateRegistration);
  this.travellerListStore = new _travellerList.default(initialState.travellerListStore);
  this.travellerStore = new _traveller.default(initialState.travellerStore);
  this.subscribeStore = new _subscribe.default(initialState.subscribeStore);
  this.verifyUserByPhone = new _verifyUserByPhone.default(initialState.verifyUserByPhone);
  this.resendVeirfyEmailStore = new _resendVerifyEmail.default(initialState.resendVeirfyEmailStore);
  this.resendVerifyPhoneStore = new _resendVerifyPhone.default(initialState.resendVerifyPhoneStore);
  this.refreshTokenStore = new _refreshToken.default(initialState.refreshTokenStore);
  this.validateFursanIdentifierStore = new _validateFursanIdentifier.ValidateFursanIdentifierStore(initialState.validateFursanIdentifierStore, $env);
  this.genericLookupStore = new _genericLookup.default(initialState.genericLookupStore, $env);
});
exports.default = ProfilePageStore;